export default __webpack_public_path__ + "b663ebc765c530fe493e140d20b32f4f.png";